import useAuth from "./useAuth";
//import useRetryFetch from "./useRetryFetch";
import { config } from "../Environment";
//import { tryGetUserRoles } from "../api/auth";

const useRefreshToken = () => {
  const { setAuth } = useAuth();
  //const retryFetch = useRetryFetch();

  const refresh = async () => {
    const storedAuthJson = localStorage.getItem("auth") ?? "{}";
    const storedAuth = JSON.parse(storedAuthJson);
    let response = await fetch(config.API_BASE + "/api/auth/refresh", {
      method: "GET",
      credentials: "include",
    });
    if (!response.ok) {
      setAuth({});
      localStorage.removeItem("auth");
      throw new Error(`Refresh failed with status: ${response.status}`);
    }
    const data = await response.json();
    const updatedAuth = data.email === storedAuth.email ? { ...storedAuth, ...data } : { ...data };

    setAuth(updatedAuth); // { email, accessToken, roles }
    console.log(`refresh storing updated auth ${JSON.stringify(updatedAuth)}`);
    localStorage.setItem("auth", JSON.stringify(updatedAuth));
    return data.accessToken;
  };

  return refresh;
};

export default useRefreshToken;
